pageId = 'page-contract-new'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  initConfirmSubmitForm($page)

initConfirmSubmitForm = ($page) ->
  $submitButton = $page.find('.form :submit')
  $confirmCheckbox = $page.find('#confirm-checkbox')

  $page
    .on 'change', '#confirm-checkbox', ->
      confirmed = $confirmCheckbox.is(':checked')
      $submitButton.prop('disabled', !confirmed)
      $submitButton[if confirmed then 'removeClass' else 'addClass']('disabled')
